import { createAsyncThunk } from '@reduxjs/toolkit';
import { eventsService } from './Events.service';
import { errorHandlerThunk } from '../../App/App.thunk';

export const getEventsListThunk = createAsyncThunk(
  `events/getEventsListThunk`,
  async (params: { page?: number }, thunkAPI) => {
    try {
      const response = await eventsService.getList(params);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);
